import script from "./Homepage.vue?vue&type=script&setup=true&lang=js"
export * from "./Homepage.vue?vue&type=script&setup=true&lang=js"

import "./Homepage.vue?vue&type=style&index=0&id=61d31b59&lang=css"

const __exports__ = script;

export default __exports__